// React
import React, { useState } from "react";
// React
// CSS
import styles from "./QuestionsBank.module.css";
// CSS
// Models
// Models
// Utils
// Utils
// Components
import { quiz_maker_back1 } from "../../Images/images";
import KonkurBooklets from "./KonkurBooklets/KonkurBooklets";
import Lessons from "./Lessons/Lessons";
import HelperHeader from "../../Utils/HelperHeader/HelperHeader";
// Components

const QuestionsBank = () => {
  // States
  //
  const [currentQuizType, setCurrentQuizType] = useState<"exam" | "konkur">(
    "exam",
  );
  const [activeGradeName, setActiveGradeName] = useState<string>("");
  // States

  return (
    <div
      className={`${styles.quizMakerContainer} flex flex-col items-center justify-between dark:!text-black`}
    >
      <div className={`${styles.topItems} w-full`}>
        <div
          className={`${styles.currentQuizTypeContainer} relative w-full flex flex-row items-center justify-between pt-2 dark:!text-black  bg-white`}
        >
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          <div
            className={`${styles.littleAbsoluteItem} absolute w-1/2 h-1 bottom-0 transition-all dark:!text-black`}
            style={{
              background:
                currentQuizType === "exam"
                  ? "rgb(0 , 150, 136)"
                  : "rgb(126 ,58 ,229)",
              left: currentQuizType === "exam" ? "50%" : "0",
            }}
          ></div>
          {/*  */}
          {/*  */}
          <button
            className={`${styles.selectorBtn} text-center w-1/2 h-full py-2 pb-4 flex items-center justify-center`}
            style={{
              color:
                currentQuizType === "konkur" ? "rgb(126, 58, 229)" : "black",
              borderLeft: "1px solid rgb(240, 240, 240)",
              ...(!activeGradeName.includes("کنکور") ? { color: "gray" } : {}),
            }}
            onClick={() => {
              setCurrentQuizType("konkur");
            }}
            disabled={!activeGradeName.includes("کنکور")}
          >
            دفترچه‌های کنکور با پاسخنامه تشریحی
          </button>
          <button
            className={`${styles.selectorBtn} text-center w-1/2`}
            style={{
              color: currentQuizType === "exam" ? "rgb(0 , 150, 136)" : "black",
            }}
            onClick={() => {
              setCurrentQuizType("exam");
            }}
          >
            نمونه سوالات امتحانی
          </button>
        </div>
        <div className={`${styles.questionCreationFormContainer}`}>
          {currentQuizType === "exam" && (
            <div className="mt-10 p-8">
              <HelperHeader
                absoluteText="درس مورد نظر را انتخاب کنید"
                isBgWhite={true}
              />
              <Lessons setActiveGradeName={setActiveGradeName} />
            </div>
          )}
          {currentQuizType === "konkur" && (
            <KonkurBooklets setActiveGradeName={setActiveGradeName} />
          )}
        </div>
      </div>
      {currentQuizType === "exam" ? (
        <img
          src={quiz_maker_back1}
          alt=""
          className="w-10/12 h-1/4 mb-5  object-contain"
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default QuestionsBank;
